// Development-only routes
// These routes are only available when NODE_ENV is 'development'
export const devRoutes =
  process.env.NODE_ENV === "development"
    ? [
        {
          path: "/dev/icons",
          lazy: async () => {
            const mod = await import("../pages/DevTools/IconShowcase");
            const IconShowcase = mod.IconShowcase ?? mod.default;
            return { Component: IconShowcase };
          },
        },
        {
          path: "/dev/hover-preview",
          lazy: async () => {
            const mod = await import("../views/Admin/Dev/HoverPreview");
            const HoverPreview = mod.default;
            return { Component: HoverPreview };
          },
        },
      ]
    : [];
